import * as React from "react";
import { view } from "../../lib/vvm";
import styles from "./Layout.module.css";
import Icon, { IconSize } from "../Icon/Icon";
import { LayoutViewModel, type LayoutViewProps } from "./LayoutViewModel";

interface LayoutProps extends LayoutViewProps {
  children?: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = view(LayoutViewModel)<LayoutProps>(
  ({ viewModel: { title, goBack }, children }) => {
    return (
      <div className={styles.root}>
        <div className={styles.header}>
          <button onClick={goBack} className={styles.backButton}>
            <Icon name={"LongArrowLeft"} size={IconSize.large} />
          </button>
          <h1>{title}</h1>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    );
  },
);
